export interface AutocompleteUserI {
  firstname: string;
  lastname: string;
  email: string;
}

export default class AutoCompleteEmail {
  defaultDomain = '';
  user: AutocompleteUserI = {
    firstname: '',
    lastname: '',
    email: '',
  };

  constructor(user?: { email: string }) {
    if (user) {
      this.defaultDomain = this.extractDomain(user.email);
    }
  }

  reset() {
    this.user = {
      firstname: '',
      lastname: '',
      email: '',
    };
  }

  autoComplete(email: string): AutocompleteUserI {
    const tmpEmail = email.trim();
    if (tmpEmail) {
      this.autoCompleteNames(tmpEmail);
    }
    return this.user;
  }

  hotSuggestion(email: string) {
    if (this.defaultDomain) {
      if (!email || email.indexOf('@') >= 0) {
        this.reset();
        return;
      }
      this.user.email = `${email}@${this.defaultDomain}`;
    }
  }

  private autoCompleteNames(email: string) {
    if (this.user.firstname === '' && this.user.lastname === '') {
      const fullnameArr = email.split('@')[0].split('.');
      this.user.firstname = this.ucfirstWords(fullnameArr[0]);
      this.user.lastname = fullnameArr[1] ? this.ucfirstWords(fullnameArr[1]) : '';
    }
  }

  private extractDomain(email: string) {
    const parts = email.split('@');
    return parts[1] || '';
  }

  private ucfirstWords(str: string) {
    return str.toLowerCase().replace(/\b[a-z]/, letter => letter.toUpperCase());
  }
}
